import { css, keyframes } from '@emotion/react';
import { PropsWithChildren, ReactElement, forwardRef } from 'react';
import { cx } from './helpers';
import { IconProps } from './icons';

export const Grid = forwardRef<
  HTMLDivElement,
  PropsWithChildren<{ className?: string }>
>((props, ref) => (
  <div className={cx('aura--grid', props.className)} ref={ref}>
    {props.children}
  </div>
));

type LabelProps = {
  label: string;
  color: string;
  backgroundColor: string;
  size?: 'xs' | 'normal';
  leftIcon?: ReactElement<IconProps>;
  rightIcon?: ReactElement<IconProps>;
};

export function Label({
  label,
  color,
  backgroundColor,
  size = 'normal',
  leftIcon,
  rightIcon,
}: LabelProps): JSX.Element {
  return (
    <span
      className={cx(
        'aura--label',
        size === 'normal' ? 'aura--copy-normal' : 'aura--copy-xs',
      )}
      css={css({ backgroundColor, color, borderRadius: 4 })}
    >
      {leftIcon}
      {label}
      {rightIcon}
    </span>
  );
}

const rotation = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

export function LoaderPro({ size = 64 }: { size?: number }): JSX.Element {
  return (
    <div
      css={css({
        flexGrow: 1,
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        css={css({ animation: `${rotation} 1s linear infinite` })}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32 60C47.464 60 60 47.464 60 32C60 16.536 47.464 4 32 4C16.536 4 4 16.536 4 32C4 47.464 16.536 60 32 60ZM32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 30C3.10457 30 4 30.8954 4 32C4 47.464 16.536 60 32 60C33.1046 60 34 60.8954 34 62C34 63.1046 33.1046 64 32 64C14.3269 64 0 49.6731 0 32C0 30.8954 0.89543 30 2 30Z"
          fill="#4036ED"
        />
      </svg>
    </div>
  );
}
